import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { bindPromiseCreators } from 'redux-saga-routines';
import { reduxForm } from 'redux-form/immutable';
import Slider from '@material-ui/lab/Slider';
import Switch from '@material-ui/core/Switch';
import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';
import FormControlLabel from '@material-ui/core/FormControlLabel';

import Button from '@material-ui/core/Button';

import ReduxDialog from '../../../Common/ReduxDialog';
import { showDialog, hideDialog } from '../../../../redux/actions/dialogs';
import { upgradeAccountPromise } from '../../../../redux/routines';

import styles from './styles';
import { CREDIT_CARD_DIALOG, UPGRADE_DIALOG } from '../../../../redux/constants/dialogs';
import { toJS } from '../../../../utils/helper';

// TODO conslidate into common
const calculateTaskPrice = (count) => {
  const price = (13.438 * (Math.pow(count, -0.7379))) + 0.25;
  return Math.min(price, 1);
};

const RETENTION_MONTHS = [1, 2, 3, 6, 12];
const RETENTION_PRICING = [0,
  5,
  9.5,
  20,
  27.5];

class UpgradeDialog extends React.Component {
  state = {
    estimatedTasks: 25,
    taskCost: 1,
    retentionPeriodIdx: 0,
    brandedApp: false,
  };

  componentWillMount() {
    const { account } = this.props;
    if (account.settings) {
      if (account.settings.retentionPeriod) {
        this.setState({
          retentionPeriodIdx: RETENTION_MONTHS.indexOf(account.settings.retentionPeriod),
        });
      }

      this.setState({
        brandedApp: account.settings.brandedApp,
      });
    }
  }

  handlePaymentSourceCreated = (token, retentionPeriod, brandedApp) => {
    this.props.upgrade({
      token,
      retentionPeriod,
      brandedApp,
    }).then(() => this.props.hideDialog(UPGRADE_DIALOG));
  };

  handleUpgrade = () => {
    const { account, showDialog } = this.props;
    const { retentionPeriodIdx, brandedApp } = this.state;
    const retentionPeriod = RETENTION_MONTHS[retentionPeriodIdx];
    if (!account.paymentSource) {
      showDialog(CREDIT_CARD_DIALOG, {
        onSave: (token) => this.handlePaymentSourceCreated(token, retentionPeriod, brandedApp),
      });
    } else {
      this.handlePaymentSourceCreated(null, retentionPeriod, brandedApp);
    }
  };

  render() {
    const { estimatedTasks, taskCost, retentionPeriodIdx, brandedApp } = this.state;

    const basePrice = 25;
    const retentionPrice = retentionPeriodIdx > 0 ? RETENTION_PRICING[retentionPeriodIdx] : 0;
    const taskPrice = estimatedTasks > 25 ? Math.round(taskCost * Math.max(0, (estimatedTasks - 25))) : 0;
    const brandedAppPrice = brandedApp ? 500 : 0;
    const total = basePrice + retentionPrice + taskPrice + brandedAppPrice;

    const actions = [
      <Button
        key="cancel"
        variant="text"
        color="primary"
        onClick={() => this.props.hideDialog(UPGRADE_DIALOG)}
      >Cancel</Button>,
      <Button
        key="upgrade"
        variant="contained"
        color="primary"
        autoFocus
        type="submit"
        onClick={this.handleUpgrade}
      >Upgrade</Button>,
    ];

    return (
      <ReduxDialog
        name={UPGRADE_DIALOG}
        title="Upgrade"
        actions={actions}
        fullWidth
        maxWidth="md"
      >
        <div style={styles.container}>
          <Grid container spacing={8} style={styles.row}>
            <Grid item xs={8} style={styles.item}>
              <Typography color="primary" variant="title">Base Charge</Typography>
            </Grid>
            <Grid item xs={4} style={styles.cost}>
              $25
            </Grid>
          </Grid>
          <Grid container spacing={8} style={styles.row}>
            <Grid item xs={8} style={styles.item}>
              <Typography color="primary" variant="title">Data Retention Period</Typography>
              <Typography color="secondary" variant="body1">How long would you like your data kept for?</Typography>
            </Grid>
            <Grid item xs={4}>
              <Slider
                min={0}
                max={4}
                step={1}
                style={styles.slider}
                value={retentionPeriodIdx}
                onChange={(evt, retentionPeriodIdx) => this.setState({ retentionPeriodIdx })}
              />
              <div style={styles.retentionPeriod}>{RETENTION_MONTHS[retentionPeriodIdx]} month(s)</div>
              <div style={styles.retentionPeriodCost}>{retentionPeriodIdx > 0 ?
                <span>${retentionPrice.toFixed(2)}</span> : <span>Included</span>}</div>
            </Grid>
          </Grid>
          <Grid container spacing={8} style={styles.row}>
            <Grid item xs={8} style={styles.item}>
              <Typography color="primary" variant="title">Estimated Task Usage</Typography>
              <Typography color="secondary" variant="body1">The more tasks you create, the cheaper the per task rate
                becomes. <b>You
                  are only billed for the tasks you use</b></Typography>
            </Grid>
            <Grid item xs={4}>
              <Slider
                min={25}
                max={1000}
                step={25}
                style={styles.slider}
                value={estimatedTasks}
                onChange={(evt, estimatedTasks) => this.setState({
                  estimatedTasks,
                  taskCost: calculateTaskPrice(estimatedTasks),
                })}
              />
              <div style={styles.count}>{estimatedTasks} tasks</div>
              <div
                style={styles.cost}>
                {estimatedTasks > 25 ? `$${taskPrice}` : 'Included'}
              </div>
            </Grid>
          </Grid>
          <Grid container spacing={8} style={styles.row}>
            <Grid item xs={8} style={styles.item}>
              <Typography variant="title" color="primary">Branded iOS and Android App</Typography>
            </Grid>
            <Grid item xs={4} style={styles.switch}>
              <FormControlLabel
                control={
                  <Switch
                    checked={brandedApp}
                    onChange={(evt, brandedApp) => this.setState({ brandedApp })}
                    value="checkedA"
                    color="primary"
                  />
                }
              />
              {brandedApp ? <div style={styles.brandedAppCost}>${brandedAppPrice}</div> : null}
            </Grid>
          </Grid>

          <Grid container spacing={8} style={styles.row}>
            <Grid item xs={8} style={styles.item}>
              <Typography color="primary" variant="display1">Monthly Total</Typography>
            </Grid>
            <Grid item xs={4}>
              <div style={styles.cost}>
                ${total.toFixed(2)}
              </div>
            </Grid>
          </Grid>
        </div>
      </ReduxDialog>
    );
  }
}

UpgradeDialog.propTypes = {
  showDialog: PropTypes.func.isRequired,
  hideDialog: PropTypes.func.isRequired,
  upgrade: PropTypes.func.isRequired,
  account: PropTypes.object.isRequired,
};

const form = reduxForm({
  form: UPGRADE_DIALOG,
  onSubmit: (values, dispatch, props) => {
    console.log('onSubmit');
  },
})(UpgradeDialog);

function mapStateToProps(state) {
  return {
    account: toJS(state.getIn(['accounts', 'account'])),
  };
}

function mapDispatchToProps(dispatch) {
  return {
    ...bindActionCreators({
      showDialog,
      hideDialog,
    }, dispatch),
    ...bindPromiseCreators({
      upgrade: upgradeAccountPromise,
    }, dispatch)
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(form);



// WEBPACK FOOTER //
// ./src/components/Admin/Billing/UpgradeDialog/index.js